/* v4.5 GRID-LOCK (Σ07-24) — blend auto-detect: το multiply «λιώνει» σωστά ΜΟΝΟ
   λευκά στούντιο φόντα· σε lifestyle (μοντέλο/περιβάλλον) σκουραίνει την εικόνα.
   Κανόνας: δειγματίζουμε τις 4 γωνιές της κύριας φωτο (canvas 8×8) — <3 λευκές
   γωνιές → .media--noblend (cover, χωρίς φίλτρο). FAIL-OPEN = multiply μένει
   (95%+ του καταλόγου = λευκές στούντιο λήψεις)· try/catch για tainted canvas.
   Απαιτεί crossorigin="anonymous" στο img (μπαίνει από product-card.liquid). */
(function () {
  'use strict';
  /* Σ08-01 plan-C (owner-QA «λευκά φόντα επιμένουν σε iPhone»): το multiply
     μεταφέρεται ΜΕΣΑ στο στοιχείο — background-image(currentSrc) + ivory +
     background-blend-mode στον wrapper (.media--bgblend), τεχνική που το iOS
     WebKit υποστηρίζει ντετερμινιστικά (σε αντίθεση με mix-blend σε layers
     και filter:url σε HTML που αποδείχθηκαν αναξιόπιστα/ανυποστήρικτα).
     Μηδέν έξτρα fetch (currentSrc = ήδη cached)· το <img> μένει στο DOM για
     SEO/alt/lightbox, απλώς αόρατο. Fail-open χωρίς JS = το filter-CSS path. */
  var SEL = '.product-card__img--primary, .pdp__img, .pdp__thumb img';
  var WRAP = '.product-card__media, .pdp__media-item, .pdp__thumb';

  function check(img) {
    if (!img.naturalWidth) return;
    var wrap = img.closest(WRAP);
    if (!wrap) return;
    try {
      /* owner-QA Σ07-24 στ΄ (chain-proven CN2205-025): το 8×8 downscale έκανε κάθε
         «γωνιά» μέσο όρο μπλοκ ~75px → προϊόν κοντά στη γωνιά = ψευδο-σκούρα.
         Νέο: δειγματίζουμε τις ΠΡΑΓΜΑΤΙΚΕΣ 4 γωνιές (8×8 SOURCE pixels → 1px η
         καθεμιά)· noblend ΜΟΝΟ με σαφή απόδειξη lifestyle (≥3/4 lum<215) —
         αμφιβολία = multiply μένει (fail-open) */
      var w = img.naturalWidth, h = img.naturalHeight;
      var c = document.createElement('canvas');
      c.width = 2; c.height = 2;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0, 8, 8, 0, 0, 1, 1);
      x.drawImage(img, w - 8, 0, 8, 8, 1, 0, 1, 1);
      x.drawImage(img, 0, h - 8, 8, 8, 0, 1, 1, 1);
      x.drawImage(img, w - 8, h - 8, 8, 8, 1, 1, 1, 1);
      var d = x.getImageData(0, 0, 2, 2).data;
      var nonwhite = 0;
      var opaque = 0;
      for (var i = 0; i < 4; i++) {
        var p = i * 4;
        if (d[p + 3] > 200) opaque++;
        var lum = (d[p] + d[p + 1] + d[p + 2]) / 3;
        if (lum < 215) nonwhite++;
      }
      /* Σ08-01β (iPhone «λευκά επιμένουν επιλεκτικά»): noblend ΜΟΝΟ με αξιόπιστο
         δείγμα — στο iOS WebKit το drawImage πριν το decode γυρίζει διάφανο-μαύρο
         (lum 0, alpha 0) = ψευδο-lifestyle. Μη-αδιαφανείς γωνιές (opaque<4) =
         αναξιόπιστο ή PNG-cutout → fail-open σε bgblend, ποτέ noblend. */
      if (opaque === 4 && nonwhite >= 3) {
        wrap.classList.add('media--noblend');
        return;
      }
    } catch (e) { /* tainted canvas κ.λπ. → fail-open: προχωράμε σε bgblend */ }
    /* plan-C v2: η φωτο περνά ως CSS custom property — το ΠΟΥ ζωγραφίζεται το
       blend το ορίζει το CSS κάθε πλαισίου (κάρτα → .product-card__link ΠΑΡΑΘΥΡΟ,
       όχι η polaroid κορνίζα — το λάθος του v1 που έθαψε τη φωτο πίσω από το
       αδιαφανές ivory· PDP item/thumb → το ίδιο το στοιχείο). iOS-αξιόπιστο:
       background-blend = εντός στοιχείου, 0 cross-layer compositing. */
    wrap.style.setProperty('--tjcb-img', 'url("' + (img.currentSrc || img.src) + '")');
    wrap.classList.add('media--bgblend');
  }

  /* Σ08-01β: (α) img.decode() πριν το δείγμα όπου υπάρχει (Safari 11.1+) —
     εγγυημένα αποσυμπιεσμένο bitmap· (β) το WebKit δίνει κατά καιρούς
     complete=true με naturalWidth=0 (χωρίς μεταγενέστερο load event) — το παλιό
     arm το άφηνε ΓΙΑ ΠΑΝΤΑ χωρίς blend (λευκό, «επιλεκτικά») → bounded retry. */
  function arm(img) {
    if (img.dataset.tjBlend) return;
    img.dataset.tjBlend = '1';
    var tries = 0;
    function run() {
      if (img.naturalWidth) {
        if (img.decode) { img.decode().then(function () { check(img); }, function () { check(img); }); }
        else { check(img); }
      } else if (++tries <= 8) {
        setTimeout(run, 350);
      }
    }
    img.addEventListener('load', run, { once: true });
    if (img.complete) run();
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll(SEL) : []).forEach(arm);
  }

  /* Σ08-01 owner-QA (κάρτες «χάνουν το μπεζ» στο κινητό): το touch-swap tracking
     του quickview.js (ιερό — ΔΕΝ αγγίζεται) κρατά ΕΝΑ slot· δεύτερο δάχτυλο ή
     γρήγορα διαδοχικά αγγίγματα στο scroll αφήνουν κάρτες κολλημένες στη 2η φωτο
     (cover/λευκή). Watchdog: μόλις η σελίδα σκρολάρει, καθαρίζονται ΟΛΑ τα
     is-touch-swap — το γνήσιο κράτημα-παρατήρηση γίνεται με ακίνητη σελίδα. */
  var swTimer;
  window.addEventListener('scroll', function () {
    clearTimeout(swTimer);
    swTimer = setTimeout(function () {
      document.querySelectorAll('.product-card__media.is-touch-swap').forEach(function (m) {
        m.classList.remove('is-touch-swap');
      });
    }, 120);
  }, { passive: true });

  scan(document);
  /* AJAX grid-rewrites (φίλτρα συλλογής / two-stream pagination) → ξανασάρωση */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
